import React, { FC } from 'react';
import { PercentCont, ResponseRateCont, ScaleCont } from './ResponseRate.styles';
import { useReports } from '../../hooks/useReports';

interface IResponseRate {
  mode: string;
  percent: number;
  responseCount: number;
  maxResponseCount: number;
}

const ResponseRate: FC<IResponseRate> = ({mode, percent, responseCount, maxResponseCount}) => {
  const {chooseRepresentativenessMode} = useReports();
  const {background, borderColor} = chooseRepresentativenessMode(mode);

  return (
    <ResponseRateCont id="ResponseRateCont" background={background} borderColor={borderColor}>
      <PercentCont id="PercentCont" color={borderColor}>{percent}%</PercentCont>
      <ScaleCont id="ScaleCont">({responseCount}/{maxResponseCount})</ScaleCont>
    </ResponseRateCont>
  );
};

export default ResponseRate;